import { useTranslation } from 'react-i18next'

import { AppShell } from '@/components/px/AppShell'
import { DensityNote } from '@/components/px/DensityNote'
import { libraryNav } from '@/components/px/nav'
import { selectActiveOrgId } from '@/features/auth/slices/sessionSlice'
import { AgentCataloguePanel } from '@/features/agents/components/AgentCataloguePanel'
import { selectAgents } from '@/features/agents/slices/agentsSlice'
import { useAppSelector } from '@/store'

/** Live organisation catalogue; descriptors remain vocabulary, agents remain instances. */
export default function AgentLibraryPage() {
  const { t } = useTranslation('agents')
  const orgId = useAppSelector(selectActiveOrgId) ?? ''
  const agents = useAppSelector(selectAgents)

  return (
    <AppShell
      moduleLabel={t('chrome.moduleLabel')}
      breadcrumb={t('chrome.breadcrumb')}
      contextPill={t('chrome.contextPill', {
        count: agents.length,
      }).toUpperCase()}
      nav={libraryNav}
    >
      <header className="flex flex-wrap items-baseline justify-between gap-x-6 gap-y-1">
        <h1 className="font-serif text-2xl font-semibold">
          {t('catalogue.title')}
        </h1>
        <p className="text-sm text-muted-foreground">{t('catalogue.lede')}</p>
      </header>
      <AgentCataloguePanel orgId={orgId} />
      <DensityNote>{t('catalogue.densityNote')}</DensityNote>
    </AppShell>
  )
}
